import { query } from '../utilities';

export const refGet = (id) => {
    return query('/ref/get/', { params: { id } });
};
